<template>
  <div class="legaledit-container" v-if="!getDataById">
    <div class="legaledit-table">
      <b-list-group>
        <b-list-group-item v-for="(field, index) in fields" :key="index">
          <div
            class="d-flex w-100 justify-content-between informations-item-title"
            style="font-size:.5rem"
          >
            <h5 class="mb-2">{{ field.label }}</h5>
          </div>
          <div>
            <p
              class="mb-0"
              style="font-size: .7rem"
              v-if="field.key == 'bidang_usaha'"
            >
              <b-form-input
                type="text"
                placeholder="Bidang Usaha"
                v-model="item[field.key]"
              />
            </p>
            <p class="mb-0" style="font-size: .7rem" v-else>
              <b-form-select
                :options="[
                  { value: true, text: 'Yes' },
                  { value: false, text: 'No' },
                ]"
                v-model="item[field.key]"
                class="list-menu"
              ></b-form-select>
            </p>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>
    <div class="legaledit-btn">
      <b-button class="btn-edit mr-1" @click="cancelEdit">Cancel</b-button>
      <b-button class="btn-edit mr-1" @click="deleteLegal">Delete</b-button>
      <b-button class="btn-edit mr-1" @click="saveEdit">Save</b-button>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { api } from '../services/config'
export default {
  name: 'legaledit',
  props: ['id'],
  data() {
    return {
      fields: [
        { key: 'bidang_usaha', label: 'Bidang Usaha' },
        {
          key: 'formulir_informasi_vendor',
          label: 'Formulir Informasi vendor',
        },
        { key: 'informasi_rekening', label: 'Informasi rekening' },
        { key: 'ktp_pengurus', label: 'KTP Pengurus' },
        { key: 'kartu_keluarga', label: 'Kartu Keluarga' },
        { key: 'akta_pendirian_perseroan', label: 'Akta Pendirian Perseroan' },
        { key: 'akta_penyesuaian_pt', label: 'Akta Penyesuaian PT' },
        {
          key: 'anggaran_dasar_terakhir_perseroan',
          label: 'Anggaran Dasar Terakhir Perseroan',
        },
        {
          key: 'akta_perubahan_pengurus_terakhir_perseroan',
          label: 'Akata Perubahan Pengurus Terakhir Perseroan',
        },
        { key: 'npwp', label: 'NPWP' },
        { key: 'sppkp_pajak', label: 'SPPKP Pajak' },
        { key: 'skt_pajak', label: 'SKT Pajak' },
        { key: 'sk_domisili_situ_ig', label: 'SK Domisili SITU IG' },
        { key: 'siup', label: 'SIUP' },
        { key: 'nib', label: 'NIB' },
        { key: 'tdp', label: 'TDP' },
        { key: 'sbu', label: 'SBU' },
        { key: 'iujk', label: 'IUJK' },
        { key: 'iu_pelayaran', label: 'IU Pelayaran' },
        { key: 'iujp', label: 'IUJP' },
        { key: 'iu_niaga', label: 'IU Niaga' },
        { key: 'financial_report', label: 'Financial Report' },
      ],
      item: {
        bidang_usaha: null,
        formulir_informasi_vendor: null,
        informasi_rekening: null,
        ktp_pengurus: null,
        kartu_keluarga: null,
        akta_pendirian_perseroan: null,
        akta_penyesuaian_pt: null,
        anggaran_dasar_terakhir_perseroan: null,
        akta_perubahan_pengurus_terakhir_perseroan: null,
        npwp: null,
        sppkp_pajak: null,
        skt_pajak: null,
        sk_domisili_situ_ig: null,
        siup: null,
        nib: null,
        tdp: null,
        sbu: null,
        iujk: null,
        iu_pelayaran: null,
        iujp: null,
        iu_niaga: null,
        financial_report: null,
      },
    }
  },
  created() {
    const self = this
    self.$store.dispatch('toggleSidebar', false)
  },
  computed: {
    getDataById() {
      const self = this
      self.getData()
    },
  },
  methods: {
    async deleteLegal() {
      const self = this
      try {
        const { data } = await axios({
          method: 'DELETE',
          url: `${api}/api/v1/legal/${self.id}`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: self.item,
        })
        if (data && data.status == 'success') {
          await self.$router.push({ name: 'legalconfig' })
          await self.$bvToast.toast(data.message, {
            title: data.status,
            toaster: 'b-toaster-top-center',
            solid: true,
            appendToast: false,
            variant: 'success',
          })
        }
      } catch (error) {}
    },
    cancelEdit() {
      const self = this
      self.$router.push({ name: 'legalconfig' })
    },
    async saveEdit() {
      this.$ga.event({
        eventCategory: 'Legal EDIT FORM',
        eventAction: 'click',
        eventLabel: `SAVE`,
      })
      const self = this
      try {
        const { data } = await axios({
          method: 'PUT',
          url: `${api}/api/v1/legal/${self.id}`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: self.item,
        })
        if (data && data.status == 'success') {
          await self.$router.push({ name: 'legalconfig' })
          await self.$bvToast.toast(data.message, {
            title: data.status,
            toaster: 'b-toaster-top-center',
            solid: true,
            appendToast: false,
            variant: 'success',
          })
        }
      } catch (error) {}
    },
    getData() {
      const self = this
      axios({
        method: 'GET',
        url: `${api}/api/v1/legal/${this.id}`,
      })
        .then(({ data }) => {
          self.item = {
            bidang_usaha: data.data.bidang_usaha,
            formulir_informasi_vendor: data.data.formulir_informasi_vendor,
            informasi_rekening: data.data.informasi_rekening,
            ktp_pengurus: data.data.ktp_pengurus,
            kartu_keluarga: data.data.kartu_keluarga,
            akta_pendirian_perseroan: data.data.akta_pendirian_perseroan,
            akta_penyesuaian_pt: data.data.akta_penyesuaian_pt,
            anggaran_dasar_terakhir_perseroan:
              data.data.anggaran_dasar_terakhir_perseroan,
            akta_perubahan_pengurus_terakhir_perseroan:
              data.data.akta_perubahan_pengurus_terakhir_perseroan,
            npwp: data.data.npwp,
            sppkp_pajak: data.data.sppkp_pajak,
            skt_pajak: data.data.skt_pajak,
            sk_domisili_situ_ig: data.data.sk_domisili_situ_ig,
            siup: data.data.siup,
            nib: data.data.nib,
            tdp: data.data.tdp,
            sbu: data.data.sbu,
            iujk: data.data.iujk,
            iu_pelayaran: data.data.iu_pelayaran,
            iujp: data.data.iujp,
            iu_niaga: data.data.iu_niaga,
            financial_report: data.data.financial_report,
          }
        })
        .catch(error => {})
    },
  },
}
</script>
<style lang="scss">
@import '~/assets/scss/components/legaledit.scss';
</style>
